import React from 'react'
import ReactHtmlParser from 'html-react-parser'
import PropTypes from 'prop-types'
import createClass from 'create-react-class'

import classNames from 'classnames'
import Input from './Input'

import $ from 'jquery'
import { desktopBreakpoint } from '../../constants'

const CircularScale = createClass({
  propTypes: {
    animated: PropTypes.bool,
    service: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    onDismissed: PropTypes.func.isRequired,
    children: PropTypes.func
  },

  getDefaultProps() {
    return {
      animated: true,
      onSubmit: () => { },
      onDismissed: () => { },
      children: () => 'Thank you for your feedback!'
    }
  },

  getInitialState() {
    return {
      dismissed: false,
      score: null
    }
  },

  componentDidMount() {
    if (window.innerWidth >= desktopBreakpoint) return
    setTimeout(
      () => $('.NPSScale-Values').animate({ scrollLeft: 40 }, 400),
      500
    )
  },

  /**
   * User clicked on a value.
   */
  onSubmit(score) {
    const { onSubmit } = this.props
    this.setState(
      {
        score
      },
      () => {
        onSubmit({ score })
      }
    )
  },

  /**
   * User clicked to dismiss this form.
   */
  onDismiss() {
    const { onDismissed } = this.props
    const { score } = this.state

    this.setState(
      {
        dismissed: true
      },
      () => {
        onDismissed({ score })
      }
    )
  },

  render() {
    const { animated, service } = this.props
    const { dismissed } = this.state

    const message = service
      ? `How likely are you to recommend <br/> ${service} to your friends and colleagues?`
      : ''

    if (dismissed) {
      return null
    }

    return (
      <div className={classNames('NPSInput', { animated })}>
        <button className="NPSInput-Close" onClick={this.onDismiss}>
          ✕
        </button>

        <div className="NPSInput-Inner">
          <p className="NPSInput-Message mobile-padding">
            {ReactHtmlParser(message)}
          </p>
          <Input
            selectedValue={this.props.selectedValue}
            onSubmit={this.onSubmit}
            service={service}
          />
        </div>
      </div>
    )
  }
})

export default CircularScale
